import { useHomeCurrency } from '@src/hooks/useHomeCurrency';
import { useMemo } from 'react';

export const useActiveBatchesFieldDefinitions = () => {
  const homeCurrency = useHomeCurrency();
  const homeCurrencySymbol = homeCurrency?.Symbol ?? 'USD';

  return useMemo(
    () => ({
      // Grouping columns
      settlementDue: {
        title: 'Settlement Due',
      },
      marketAccount: {
        title: 'Market Account',
      },
      batchId: {
        title: 'Batch ID',
      },

      // Data columns
      asset: {
        title: 'Asset',
        tooltip: 'The asset to be settled in the batch.',
      },
      status: {
        title: 'Status',
        tooltip:
          'For a batch row, shows the settlement state of the batch. For an asset row, shows the settlement state of that asset obligation within the batch.',
      },
      direction: {
        title: 'Direction',
        tooltip: 'Indicates whether the asset is to be sent (outgoing) or received (incoming).',
      },
      subAccount: {
        title: 'Sub Account',
        tooltip: 'The sub account where trades in the batch were allocated.',
      },
      batchProgress: {
        title: 'Batch Progress',
        tooltip:
          'The completion progress of all settlements in the batch, including both outgoing and incoming amounts.',
      },
      outgoing: {
        title: 'Outgoing',
        tooltip: 'The total amount of the asset to be sent as part of the batch.',
      },
      incoming: {
        title: 'Incoming',
        tooltip: 'The total amount of the asset to be received as part of the batch.',
      },
      unsettledAmount: {
        title: 'Unsettled Amount',
        tooltip: 'The portion of the asset in the batch that remains unsettled.',
      },
      unsettledAmountHome: {
        title: `Unsettled Amount (${homeCurrencySymbol})`,
        tooltip: `The unsettled portion of the asset, converted into home currency (${homeCurrencySymbol}).`,
      },
      totalTransactions: {
        title: 'Total Transactions',
        tooltip: 'The number of transactions included in the batch.',
      },
      createdBy: {
        title: 'Created By',
        tooltip: 'The user or system that created the batch.',
      },
      counterparty: {
        title: 'Counterparty',
      },
      settlementComplete: {
        title: 'Settlement Complete',
        tooltip: 'The time the batch was fully settled and completed.',
      },
    }),
    [homeCurrencySymbol]
  );
};
